var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKBlu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.015,
    y1: 0.5,
    x2: 0.962,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#004ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.024,
    stopColor: "#004fa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#0e74bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#1991ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#20a6db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#25b2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#27b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.07,
    y1: 0.257,
    x2: 0.527,
    y2: 0.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#004ea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#0762b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#1281c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#1b98d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#22a9dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#25b3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#27b7e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54077",
    "data-name": "Group 54077",
    transform: "translate(-27 -135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38801",
    "data-name": "Path 38801",
    d: "M57.727,135h-7.1l-8.356,8.7v7.248Z",
    transform: "translate(-9.27 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4935",
    "data-name": "Rectangle 4935",
    width: 6.002,
    height: 24,
    transform: "translate(27 135)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38802",
    "data-name": "Path 38802",
    d: "M61.546,174.015l-9.862-14.4-4.015,4.143,6.909,10.257Z",
    transform: "translate(-12.546 -15.015)",
    fill: "url(#linear-gradient-2)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKBlu);
export default __webpack_public_path__ + "static/media/k_blu.e0571c0e.svg";
export { ForwardRef as ReactComponent };